module.exports = __webpack_public_path__ + "img/cr.2c8a0b15.svg";